import { requestIdleCallback } from "@theme/utilities";

class SCVariantSwatches extends HTMLElement {
  connectedCallback() {
    requestIdleCallback(() => this.#init());
  }

  #init() {
    const container = this.querySelector(".variant-swatches-container");
    const arrowLeft = this.querySelector(".variant-swatches-arrow--left");
    const arrowRight = this.querySelector(".variant-swatches-arrow--right");

    if (!container || !arrowLeft || !arrowRight) return;

    const updateArrows = () => {
      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;
      const isScrollable = scrollWidth > clientWidth;

      if (!isScrollable) {
        arrowLeft.classList.remove("is-visible");
        arrowRight.classList.remove("is-visible");
        return;
      }

      const scrollLeft = container.scrollLeft;
      const maxScroll = scrollWidth - clientWidth;

      arrowLeft.classList.toggle("is-visible", scrollLeft > 0);
      arrowRight.classList.toggle("is-visible", scrollLeft < maxScroll - 1);
    };

    arrowLeft.addEventListener("click", () => {
      const itemWidth =
        container.querySelector(".variant-swatch")?.offsetWidth || 80;
      container.scrollBy({ left: -itemWidth, behavior: "smooth" });
    });

    arrowRight.addEventListener("click", () => {
      const itemWidth =
        container.querySelector(".variant-swatch")?.offsetWidth || 80;
      container.scrollBy({ left: itemWidth, behavior: "smooth" });
    });

    container.addEventListener("scroll", updateArrows);
    new ResizeObserver(updateArrows).observe(container);
    updateArrows();
  }
}

if (!customElements.get("sc-variant-swatches")) {
  customElements.define("sc-variant-swatches", SCVariantSwatches);
}
